import { ConflictStore } from "sh-conflict-store";
import { mutatorAction } from "satcheljs";

export default mutatorAction('SET_IGNORED_CONFLICTS_ON_LONG_SHIFTS', function setIgnoredConflictsOnLongShifts(didIgnoreConflictsOnLongShifts: boolean) {
   ConflictStore().didIgnoreConflictsOnLongShifts = didIgnoreConflictsOnLongShifts;
});
